import axios from 'axios';
import Config from '@/Config';

const host = Config.host + "PAYS/"

function payOneMonth(reference) {
    return axios.post(`${host}PayOneMonth`, { reference })
      .then(response => {
        console.log("Pago generado exitosamente:", response.data);
        return response.data;
      })
      .catch(error => {
        console.error("Error generando pago:", error);
        throw error;
      });
  }

/**
 * Pide al backend que confirme la transaccion con Wompi. El backend no le cree
 * al navegador: consulta a Wompi y devuelve el estado real ({ status }).
 */
function confirmar(transactionId) {
  return axios.post(`${host}confirm`, { transactionId })
    .then(response => response.data)
}

export default {
  payOneMonth,
  confirmar
}